import { getUserGeoInfo, loginUserApi } from "data/slices/login/api";
import { LoginResponseProps } from "data/slices/login/interface";
import keys from "locale/keys";
import { isEmpty, isUndefined } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { DASHBOARD_DEFAULT_ROUTE, ROUTES } from "utils/constants";
import { saveTokens } from "utils/Utils";
import PURE from "widgets/prelogin/login";

import { LoginContainerProps } from "../interface";

const LoginContainer = (props: LoginContainerProps) => {
  const { onShowSnackbarHandler } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const onLoginButtonClickedHandler = (username: string, password: string) => {
    getUserGeoDetails(username, password);
  };

  const getUserGeoDetails = async (username: string, password: string) => {
    setIsLoading(true);
    const userGeoInfo = await getUserGeoInfo();
    setIsLoading(false);

    loginUser(username, password, userGeoInfo?.ip);
  };

  const loginUser = async (username: string, password: string, ip?: string) => {
    setIsLoading(true);

    const { innerWidth, innerHeight } = window;

    const loginResponse: LoginResponseProps = await loginUserApi({
      email: username,
      password,
      width: innerWidth,
      height: innerHeight,
      ip: ip ?? "",
    });

    setIsLoading(false);
    if (isUndefined(loginResponse) || isEmpty(loginResponse)) {
      onShowSnackbarHandler(t(keys.generic_error));
    } else if (!isEmpty(loginResponse.error)) {
      onShowSnackbarHandler(loginResponse.message);
    } else {
      saveTokens({
        ...loginResponse.response,
        isInitialSurvey: loginResponse?.isInitialSurvey, // The initial survey status takes directly from the response
      });
      loginResponse.response?.isFirstLogin ||
      loginResponse?.isInitialSurvey === false
        ? navigate(ROUTES.WELCOME, {
            replace: true,
          })
        : navigate(DASHBOARD_DEFAULT_ROUTE, {
            replace: true,
          });
    }
  };

  const onForgotPasswordClickedHandler = () => {
    navigate(ROUTES.FORGOT_PASSWORD);
  };

  const onSingupButtonClickedHandler = () => {
    navigate("/signup");
  };

  return (
    <PURE
      onForgotPasswordHandler={onForgotPasswordClickedHandler}
      onLoginHandler={onLoginButtonClickedHandler}
      onSignupHandler={onSingupButtonClickedHandler}
      isLoading={isLoading}
    />
  );
};

export default LoginContainer;
